import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'auth/setAuth0User',
          'auth/setSigninResponse',
          'auth/checkEmailVerification/pending',
          'auth/checkEmailVerification/fulfilled',
          'auth/checkEmailVerification/rejected',
          'auth/signInToBackend/pending',
          'auth/signInToBackend/fulfilled',
          'auth/signInToBackend/rejected',
          'auth/resendVerificationEmail/pending',
          'auth/resendVerificationEmail/fulfilled',
          'auth/resendVerificationEmail/rejected',
          'auth/fetchWhoami/pending',
          'auth/fetchWhoami/fulfilled',
          'auth/fetchWhoami/rejected',
        ],
        ignoredActionPaths: [
          'payload.auth0User',
          'payload.signinResponse',
          'meta.arg.evalToken',
          'meta.arg.signIn',
          'meta.arg.resendVerificationEmail',
          'meta.arg.auth0User',
          'meta.arg.whoami',
        ],
        ignoredPaths: ['auth.auth0User', 'auth.signinResponse'],
      },
    }),
});

